import {remCalc} from '_themeUtils'

const productRequestSize = {
    ProductRequestSize: {
        baseStyle: () => ({
            // ─── Drawer content ───────────────────────────────────────────
            // Figma 5661-13019: header→intro gap 24, intro→inputs gap 24.
            container: {
                alignItems: 'flex-start',
                gap: 'spacing.6',
                w: '100%',
            },
            textContainer: {
                alignItems: 'flex-start',
                gap: 'spacing.3',
                w: '100%',
            },
            // Figma: fields stacked with 10px gap.
            inputContainer: {
                alignItems: 'flex-start',
                gap: remCalc(10),
                w: '100%',
            },
            privacyMessage: {
                textStyle: 'paragraphXs',
                textAlign: 'left',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    'a, a:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
            recaptchaMessage: {
                textStyle: 'paragraphXs',
                textAlign: 'left',
                color: 'color.text.grey.700',
                fontWeight: 400,
                sx: {
                    'a, a:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
            // Wrapper around the two privacy lines: 15px between them, 24px before the CTA (Figma).
            privacyContainer: {
                gap: remCalc(15),
                mt: 'spacing.6',
                mb: 'spacing.6',
            },
            subtitle: {
                textStyle: 'paragraphSm',
                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            requiredFieldsText: {
                textStyle: 'paragraphXs',
            },
            errorMessage: {
                w: '100%',
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
            // ─── Success confirmation (Figma 58338-20035): heading + body ──
            successContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.4',
            },
            successMessage: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
        }),
    },
}

export default productRequestSize
